var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5fptkqx51a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v1641H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n9h75t5elb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26 0v5.73H0V0h5.26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y4xxva2n7c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.762 0v3.386c0 .305.07.54.187.658.141.141.376.188.658.188.305 0 .517-.047.634-.188.14-.117.211-.353.211-.658V0h1.785v3.527c0 .682-.235 1.246-.681 1.599-.446.353-1.104.564-1.949.564S1.081 5.48.657 5.126C.236 4.773 0 4.209 0 3.526V0h1.762z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jabga0revd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.69 0 1.55 2.61c.048.07.118.165.165.305.047.118.117.306.188.494 0-.07-.023-.212-.023-.305 0-.142-.024-.282-.024-.447V0h1.69v5.596h-1.69L1.949 3.033c-.023-.094-.117-.188-.165-.33a5.585 5.585 0 0 1-.164-.47c0 .071.047.212.047.283 0 .117.024.282.024.47v2.61H0V0h1.69z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1493j9zyke"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.761 0v5.596H0V0h1.761z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "53qqpr6hff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.208 0 .774 1.41L3.804 0h1.997L3.969 2.704 5.87 5.596H3.804L2.96 4.091l-.846 1.505-.164-2.892L.211 0h1.997z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "axyc513c4g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.899 0v2.87H0V0h2.899z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fx9q6n8hwh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.433 0c.187 0 .375.024.54.094.164.094.352.188.493.33.117.117.211.281.282.446.094.188.14.4.14.588 0 .165-.046.353-.117.517-.094.188-.188.353-.305.47a1.553 1.553 0 0 1-.47.33 2.185 2.185 0 0 1-.587.094c-.164 0-.352-.047-.517-.094a1.31 1.31 0 0 1-.47-.33C.306 2.328.165 2.163.118 2A1.5 1.5 0 0 1 0 1.458c0-.188.047-.376.117-.565C.164.73.305.541.423.423.54.284.705.165.869.095 1.033.024 1.221 0 1.41 0h.024zm0 .282c-.165 0-.306.047-.447.094a.914.914 0 0 0-.352.259 1.08 1.08 0 0 0-.258.376c-.047.118-.07.282-.07.423 0 .141.023.306.07.447.047.118.164.282.235.376.117.095.258.188.375.235.141.047.306.095.447.095.14 0 .305-.048.422-.095.141-.047.282-.14.4-.258.093-.07.211-.212.235-.33.046-.14.093-.305.093-.47a1.25 1.25 0 0 0-.093-.423C2.442.871 2.325.73 2.255.635 2.137.54 2.02.446 1.879.4a.897.897 0 0 0-.446-.118zm.023.353c.212 0 .4.023.517.117.117.095.188.212.188.33a.502.502 0 0 1-.094.282c-.024.07-.141.14-.235.14l.352.683H1.62l-.258-.588h-.047v.588H.798V.635h.658zm-.07.282h-.07v.376h.093c.07 0 .141 0 .188-.023.023-.024.047-.094.047-.165a.25.25 0 0 0-.047-.117C1.55.94 1.456.917 1.386.917z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5fptkqx51a)",
    transform: "translate(-478 -916)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n9h75t5elb)",
    transform: "translate(478 925.703)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y4xxva2n7c)",
    transform: "translate(0 .04)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231E1F",
    d: "M0 0h5.237v5.69H0V0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jabga0revd)",
    transform: "translate(484.364 925.743)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231E1F",
    d: "M0 0h5.237v5.596H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1493j9zyke)",
    transform: "translate(490.728 925.743)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231E1F",
    d: "M0 0h1.761v5.596H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53qqpr6hff)",
    transform: "translate(493.077 925.743)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231E1F",
    d: "M0 0h5.87v5.596H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#axyc513c4g)",
    transform: "translate(499.101 924.567)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fx9q6n8hwh)",
    transform: "translate(.01)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231E1F",
    d: "M0 0h2.888v2.869H0V0z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnix);
export default __webpack_public_path__ + "static/media/unix.6a52cf24d8fc143080f6962b0e66f61a.svg";
export { ForwardRef as ReactComponent };